import PhotoSwipeLightbox from 'photoswipe/lightbox'
import PhotoSwipe from 'photoswipe'
import 'photoswipe/style.css'
import { canEnableSwiperLoop } from './utils'

window.PhotoSwipeLightbox = PhotoSwipeLightbox
window.PhotoSwipe = PhotoSwipe

export default () => ({
    swiper: null,
    init () {
        this.checkBreakpoint()

        this.startLightbox()
    },
    enable () {
        const breakpoints = {
            320: {
                slidesPerView: 1.5,
                pagination: false,
                direction: 'horizontal',
                spaceBetween: 7.5,
            },
            768: {
                slidesPerView: 1,
                pagination: false,
                direction: 'vertical',
            },
        }

        this.swiper = new Swiper(this.$refs.productImagesCarousel, {
            slidesPerView: 1.5,
            spaceBetween: 15,
            loop: canEnableSwiperLoop(this.$refs.productImagesCarousel, { slidesPerView: 1.5, breakpoints }),
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints,
            autoplay: {
                delay: 333000,
                disableOnInteraction: false,
            },
            // keyboard control
            keyboard: {
                enabled: true,
            },
        })
    },
    startLightbox () {
        const lightbox = new PhotoSwipeLightbox({
            gallery: '#productMedia',
            pswpModule: () => import('photoswipe'),
            bgOpacity: 1,
            showHideOpacity: true,
            children: 'a',
            loop: true,
            showHideAnimationType: 'zoom',
            imageClickAction: 'zoom',
            tapAction: 'zoom',
            mouseMovePan: true,
            initialZoomLevel: 'fit',
            secondaryZoomLevel: 1.5,
            maxZoomLevel: 1,
            zoom: true,
            close: true,
            counter: true,
            arrowKeys: true,
            wheelToZoom: true,
        })

        lightbox.init()

        lightbox.on('change', () => {
            const { pswp } = lightbox

            if (this.swiper) {
                this.swiper.slideTo(pswp.currIndex, 0, false)
            }
        })

        lightbox.on('afterInit', () => {
            const { pswp } = lightbox

            if (this.swiper && this.swiper.params.autoplay.enabled) {
                this.swiper.autoplay.stop()
            }
            console.log('afterInit')
        })

        lightbox.on('closingAnimationStart', () => {
            const { pswp } = lightbox

            if (this.swiper) {
                this.swiper.slideTo(pswp.currIndex, 0, false)
                if (this.swiper.params.autoplay.enabled) {
                    this.swiper.autoplay.start()
                }
            }
        })
    },

    checkBreakpoint () {
        const mediaQuery = '(max-width: 768px)'
        const mediaQueryList = window.matchMedia(mediaQuery)

        if (mediaQueryList.matches) {
            this.enable()
        } else {
            if (this.swiper) {
                this.swiper.destroy(true, true)
            }
        }

        mediaQueryList.addEventListener('change', event => {
            if (event.matches) {
                this.enable()
            } else {
                if (this.swiper) {
                    this.swiper.destroy(true, true)
                }
            }
        })
    },
});
